// Vuetify tooltip directive wrapper
// Since Vuetify uses v-tooltip component instead of directive,
// this directive adds a simple title attribute as fallback
export default {
  mounted(el, binding) {
    // Set title attribute for native browser tooltip
    el.setAttribute('title', binding.value || '');
    
    // Add data attribute for potential future Vuetify integration
    el.setAttribute('data-tooltip', binding.value || '');
  },
  updated(el, binding) {
    // Update tooltip content if it changes
    if (binding.value !== binding.oldValue) {
      el.setAttribute('title', binding.value || '');
      el.setAttribute('data-tooltip', binding.value || '');
    }
  },
  beforeUnmount(el) {
    // Clean up attributes
    el.removeAttribute('title');
    el.removeAttribute('data-tooltip');
  }
};